module.exports = __webpack_public_path__ + "static/sam-harris-fac12d0f73cb8d6bd2a1e7d3f907b411.jpg";